import { AGGREGATES, ASN_STATUS, AGGREGATE_STATUS } from './constants';
import { renderShift } from './utils/shiftUtils';

export const OPTIONAL_ATTRIBUTES = {
  FAMILY: 'Family',
  ORDER_FREQUENCY: 'Order Frequency',
  POWER_STEERING: 'Power Steering',
  BUILD_CARD_NUMBER: 'Build Card Number',
  SHIFT: 'Shift',
  MARKET: 'Market',
  CATEGORY: 'Category',
  COUNTRY: 'Country',
  DEFENCE: 'Defence',
  FBV: 'FBV',
  FBV_VENDOR_CODE: 'FBV Vendor Code',
  FBV_VENDOR_NAME: 'FBV Vendor Name',
  LINE: 'Line',
  COLOUR: 'Colour',
  EVR_NUMBER: 'Evr Number'
};

export const optionalColumns = [
  {
    title: OPTIONAL_ATTRIBUTES.FAMILY,
    field: 'family',
    name: OPTIONAL_ATTRIBUTES.FAMILY,
    width: 100,
    style: {
      textAlign: 'left',
    },
  },

  {
    title: OPTIONAL_ATTRIBUTES.ORDER_FREQUENCY,
    field: 'orderFrequency',
    name: OPTIONAL_ATTRIBUTES.ORDER_FREQUENCY,
    width: 150,
    style: {
      textAlign: 'center',
    },
  },

  {
    title: OPTIONAL_ATTRIBUTES.POWER_STEERING,
    field: 'powerSteering',
    name: OPTIONAL_ATTRIBUTES.POWER_STEERING,
    width: 150,
    style: {
      textAlign: 'center',
    },
  },
  {
    title: OPTIONAL_ATTRIBUTES.BUILD_CARD_NUMBER,
    field: 'buildCardNumber',
    name: OPTIONAL_ATTRIBUTES.BUILD_CARD_NUMBER,
    width: 170,
    style: {
      textAlign: 'center',
    },
  },
  {
    title: OPTIONAL_ATTRIBUTES.MARKET,
    field: 'market',
    name: OPTIONAL_ATTRIBUTES.MARKET,
    width: 90,
    style: {
      textAlign: 'center',
    },
  },
  {
    title: OPTIONAL_ATTRIBUTES.CATEGORY,
    field: 'category',
    name: OPTIONAL_ATTRIBUTES.CATEGORY,
    width: 105,
    style: {
      textAlign: 'center',
    },
  },
  {
    title: OPTIONAL_ATTRIBUTES.COUNTRY,
    field: 'country',
    name: OPTIONAL_ATTRIBUTES.COUNTRY,
    width: 100,
    style: {
      textAlign: 'centre',
    },
  },
  {
    title: OPTIONAL_ATTRIBUTES.DEFENCE,
    field: 'defence',
    name: OPTIONAL_ATTRIBUTES.DEFENCE,
    width: 100,
    style: {
      textAlign: 'center',
    },
  },
  {
    title: OPTIONAL_ATTRIBUTES.FBV,
    field: 'fbv',
    name: OPTIONAL_ATTRIBUTES.FBV,
    width: 70,
    style: {
      textAlign: 'center',
    },
  },
  {
    title: OPTIONAL_ATTRIBUTES.FBV_VENDOR_CODE,
    field: 'fbvVendorCode',
    name: OPTIONAL_ATTRIBUTES.FBV_VENDOR_CODE,
    width: 160,
    style: {
      textAlign: 'center',
    },
  },
  {
    title: OPTIONAL_ATTRIBUTES.FBV_VENDOR_NAME,
    field: 'fbvVendorName',
    name: OPTIONAL_ATTRIBUTES.FBV_VENDOR_NAME,
    width: 200,
    style: {
      textAlign: 'left',
    },
  },
  {
    title: OPTIONAL_ATTRIBUTES.COLOUR,
    field: 'colourCode',
    name: OPTIONAL_ATTRIBUTES.COLOUR,
    width: 200,
    style: {
      textAlign: 'left',
    },
  },
  {
    title: OPTIONAL_ATTRIBUTES.EVR_NUMBER,
    field: 'evrNumber',
    name: OPTIONAL_ATTRIBUTES.EVR_NUMBER,
    width: 150,
    style: {
      textAlign: 'left',
    },
  },
];
export const optionalColumnsExceptCv = [
  {
    title: OPTIONAL_ATTRIBUTES.FAMILY,
    field: 'family',
    name: OPTIONAL_ATTRIBUTES.FAMILY,
    width: 100,
    style: {
      textAlign: 'left',
    },
  },
];
export const optionalColumnsWithShift = [
  ...optionalColumns,
  {
    title: OPTIONAL_ATTRIBUTES.SHIFT,
    field: 'shiftName',
    name: OPTIONAL_ATTRIBUTES.SHIFT,
    width: 70,
    render: col => renderShift(col),
  },
];

export const optionalColumnsForPVWithShift = [
  ...optionalColumnsExceptCv,
  {
    title: OPTIONAL_ATTRIBUTES.SHIFT,
    field: 'shiftName',
    name: OPTIONAL_ATTRIBUTES.SHIFT,
    width: 70,
    render: col => renderShift(col),
  },
];

export const filterOptions = [
  { field: 'family', name: OPTIONAL_ATTRIBUTES.FAMILY },
  { field: 'orderFrequency', name: OPTIONAL_ATTRIBUTES.ORDER_FREQUENCY },
  { field: 'market', name: OPTIONAL_ATTRIBUTES.MARKET },
  { field: 'category', name: OPTIONAL_ATTRIBUTES.CATEGORY },
  { field: 'country', name: OPTIONAL_ATTRIBUTES.COUNTRY },
  { field: 'fbv', name: OPTIONAL_ATTRIBUTES.FBV },
  { field: 'defence', name: OPTIONAL_ATTRIBUTES.DEFENCE },
  { field: 'fbvVendorCode', name: OPTIONAL_ATTRIBUTES.FBV_VENDOR_CODE },
  { field: 'fbvVendorName', name: OPTIONAL_ATTRIBUTES.FBV_VENDOR_NAME },
  { field: 'colourCode', name: OPTIONAL_ATTRIBUTES.COLOUR },
];

export const filterOptionsForPV = [
  { field: 'family', name: OPTIONAL_ATTRIBUTES.FAMILY },
  { field: 'orderFrequency', name: OPTIONAL_ATTRIBUTES.ORDER_FREQUENCY },
];

export const reasons = [
  'Material Shortage',
  'Aggregate Shortage',
  'Material Quality Issue',
  'Aggregate Quality Issue',
  'Priority change',
  'Manpower shortage',
  'Machine breakdown',
  'Process Issue',
  'Design Issue',
  'Master data',
];

export const agencies = [
  'SCM',
  'Quality',
  'BIW',
  'Frame',
  'Axle',
  'Engine',
  'Gearbox',
  'Cab',
  'Paint',
  'Chassis',
  'S&OP',
  'ERC',
  'MDM',
];

export const aggregateReasons = [
  'Material Shortage',
  'Machine Breakdown',
  'Manpower Shortage',
  'Aggregate Quality Issue',
  'New Aggregate',
  'Aggregate Unavailability',
  'Priority Change',
  'Transportation Issues',
  'Material Quality Issue',
  'Wrong Part fitment',
  'Chassis Plan change',
  'Aggregate Plan Change',
  'LineOut at Chassis',
  'SPD',
  'CKD',
];

export const aggregateAgencies = [
  'SCM',
  'Maintenance',
  'PSD',
  'Quality',
  'NPI',
  'BIW',
  'Cab',
  'Paint',
  'Frame',
  'Engine',
  'Transmission',
  'Axle',
  'SQ',
  'AQ',
  'Central PPC',
  'S&OP',
  'Aggregate PPC',
  'Transport',
];

export const aggregateLineMap = {
  [AGGREGATES.ENGINE]: 12,
  [AGGREGATES.REAR_AXLE]: 13,
  [AGGREGATES.FRONT_AXLE]: 14,
  [AGGREGATES.FRAME]: 15,
  [AGGREGATES.CAB]: 16,
  [AGGREGATES.GEAR_BOX]: '',
  [AGGREGATES.PAINT]: '',
  [AGGREGATES.BIW]: '',
};

export const aggregateUrlStringMap = {
  [AGGREGATES.ENGINE]: 'engine',
  [AGGREGATES.CAB]: 'cab-cowl',
  [AGGREGATES.REAR_AXLE]: 'rear-axle',
  [AGGREGATES.FRAME]: 'frame',
  [AGGREGATES.FRONT_AXLE]: 'front-axle',
  [AGGREGATES.GEAR_BOX]: 'gearbox',
  [AGGREGATES.PAINT]: 'paint',
  [AGGREGATES.BIW]: 'biw',
  [AGGREGATES.MATERIAL]: 'material',
  [AGGREGATES.CYLINDER_HEAD]: 'cylinder-head',
  [AGGREGATES.CYLINDER_BLOCK]: 'cylinder-block',
  [AGGREGATES.CAMSHAFT]: 'camshaft',
  [AGGREGATES.CRANKSHAFT]: 'crankshaft',
  [AGGREGATES.INTERPLANT_AGGREGATE_ASSIGNMENT]: 'interplant_aggregate_assignment',
};

export const aggregateLabelMap = {
  [AGGREGATES.ENGINE]: 'Engine',
  [AGGREGATES.CAB]: 'Cab',
  [AGGREGATES.REAR_AXLE]: 'Rear Axle',
  [AGGREGATES.FRAME]: 'Frame',
  [AGGREGATES.FRONT_AXLE]: 'Front Axle',
  [AGGREGATES.GEAR_BOX]: 'Gear box',
  [AGGREGATES.PAINT]: 'Paint',
  [AGGREGATES.BIW]: 'BIW',
  [AGGREGATES.MATERIAL]: 'Material',
  [AGGREGATES.CYLINDER_HEAD]: 'Cylinder head',
};

export const statusStringMap = {
  [ASN_STATUS.READY_FOR_DROP]: 'Ready for drop',
  [ASN_STATUS.LINE_OUT]: 'Line out',
  [AGGREGATE_STATUS.LINED_OUT]: 'Line out',
  [ASN_STATUS.LINE_ON]: 'Line on',
  [ASN_STATUS.PLANNED]: 'Planned',
  [AGGREGATE_STATUS.ASN_GENERATED]: 'Pending',
  [ASN_STATUS.DROPPED]: 'Dropped',
  [ASN_STATUS.ROLLED_OUT]: 'Rolled',
  [ASN_STATUS.WTCL]: 'WTCL',
  [ASN_STATUS.SFLT]: 'SFLT',
  [AGGREGATE_STATUS.DISPATCHED]: 'Dispatched',
  [AGGREGATE_STATUS.READY_FOR_PICKUP]: 'Dispatched', // TODO: check if there is an explicit dispatched state in the backend
  [AGGREGATE_STATUS.BOOKED]: 'Booked',
  [AGGREGATE_STATUS.PLANNED]: 'Pending',
};

export const shopType = {
  [AGGREGATES.ENGINE]: 'Engine',
  [AGGREGATES.CAB]: 'Cab',
  [AGGREGATES.REAR_AXLE]: 'Rear Axle',
  [AGGREGATES.FRAME]: 'Frame',
  [AGGREGATES.FRONT_AXLE]: 'Front Axle',
  [AGGREGATES.GEAR_BOX]: 'Gear box',
  [AGGREGATES.PAINT]: 'Paint',
  [AGGREGATES.BIW]: 'BIW',
  [AGGREGATES.CYLINDER_HEAD]: 'Cylinder head',
  [AGGREGATES.CYLINDER_BLOCK]: 'Cylinder block',
  [AGGREGATES.CAMSHAFT]: 'Camshaft',
  [AGGREGATES.CRANKSHAFT]: 'Crankshaft',
};

export const ALL_MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

export const PRODUCTION_REVIEW_TABS = {
  LINE_OUT: 'LineOut',
  PLAN_VS_ACTUAL: 'Plan vs Actual',
  PLAN_REVISIONS: 'Plan Revision',
  SEQUENCE_ADHERENCE: 'Seq. Adherence',
  EXCEPTION: 'Exception',
};

export const EXCEPTION_GRAPH_TYPE = {
  EMERGENCY_ASN: 'emergency-asn',
  ARCHIVED_ASN: 'archived-asn',
};
